import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CommonModule } from '@angular/common';
import { ProcessTextResultsService } from 'src/app/core/api/services';
import { TextPopoverDirective } from 'src/app/core/directives/text-popover.directive';
import { TranslationModule } from 'src/app/i18n';
import { ShareModule } from 'src/app/shared/share.module';
import {
  CustomResultOfPaginatedListOfGetProcessTextResultsWithPaginationDto,
  GetProcessTextResultsWithPaginationDto,
} from '../../../core/api/models';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { PagesSharedModule } from '../../shared/pages-shared.module';

@Component({
  selector: 'app-process-text-results',
  templateUrl: './process-text-results.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ShareModule,
    TranslationModule,
    PagesSharedModule,
    TextPopoverDirective,
  ],
})
export class ProcessTextResultsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  currentService = inject(ProcessTextResultsService);

  pageName = 'processTextResults';

  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetProcessTextResultsWithPaginationDto>;
  items$: Observable<Array<GetProcessTextResultsWithPaginationDto>>;

  //#endregion

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAddBtn = false;
    this.pageConfig.showAuditBtn = false;
    this.pageConfig.tableConfig.showOperationColumn = false;
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.id,
        type: 'number',
        name: 'scheduledMessageId',
        hasSearch: true,
      },
      { title: 'common.userName', name: 'userName', hasSearch: true },
      {
        title: 'common.organizationName',
        name: 'organizationName',
        hasSearch: true,
      },
      { title: 'common.word', name: 'word', hasSearch: true },
      {
        title: 'common.method',
        name: 'method',
        hasSearch: true,
      },
      {
        title: 'common.textBody',
        name: 'smsText',
        hasSearch: true,
      },
      {
        title: 'common.score',
        name: 'score',
        type: 'number',
        hasSearch: true,
      },
      {
        title: 'common.rank',
        name: 'rank',
        type: 'number',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetProcessTextResultsWithPaginationDto> {
    return this.currentService.processTextResultsGetProcessTextResultsWithPagination(
      {
        body: this.getBaseModelWithPaginationParams(),
      }
    );
  }

  //#endregion
}
